﻿import {
	InstallationByHostData,
	PermitFullEntityResult, ResidencyPropertyFlags,
	ResidencyId,
	ResidencyResult
} from "@2d-front-monorepo/permits-business";
import {JSX} from "react";
import {ResidencyComponent} from "./ResidencyComponent";

export function ResidencyWithChangeComponent({installation, residency, hiddenEntityProperties, changedResidency}: {
	installation: InstallationByHostData,
	residency: PermitFullEntityResult<ResidencyId, ResidencyResult>,
	hiddenEntityProperties: ResidencyPropertyFlags,
	changedResidency: PermitFullEntityResult<ResidencyId, ResidencyResult> | undefined,
}): JSX.Element | undefined {
	if (!changedResidency) {
		return <ResidencyComponent residency={residency} installation={installation} hiddenEntityProperties={hiddenEntityProperties} showStatus={false}/>;
	}

	return <div className="grid">
		<div className="col-1of2"><ResidencyComponent residency={residency} installation={installation} hiddenEntityProperties={hiddenEntityProperties} showStatus={true}/></div>
		<div className="col-1of2"><ResidencyComponent residency={changedResidency} installation={installation} hiddenEntityProperties={hiddenEntityProperties} showStatus={true}/>
		</div>
	</div>
}
